<template>
  <Listbox
    v-if="items.length"
    :options="items"
    optionLabel="label"
    @change="selectItem"
  />
</template>

<script setup lang="ts">
  import Listbox from "primevue/listbox";

  const props = defineProps<{
    items: Array<{ id: string; label: string }>;
    command: (item: { id: string; label: string }) => void;
  }>();

  const selectItem = (event: { value: { id: string; label: string } }) => {
    props.command(event.value);
  };
</script>
